export default {
  create_a_survey: 'Create a survey',
  from_empty: 'From Empty',
  from_template: 'From Template',
  responses: 'Responses',
  surveyStatus: {
    PUBLIC: 'Public',
    PRIVATE: 'Private',
    OFF: 'Off',
    ENDED: 'Ended',
    COMING_SOON: 'Coming Soon',
    REPLY_FULL: 'Reply Full'
  },
  title: 'Title',
  status: 'Status',
  allStatus: 'All Status',
  createtime: 'Create Time',
  reply_count: 'Number Of Responses',
  table: {
    show: 'Show',
    to: 'to',
    unit: 'item',
    total: 'Total',
    dataText: 'items',
    comma: ', ',
    selectTag: 'Select Tag'
  },
  menu: {
    edit: 'Edit',
    preview: 'Preview',
    move: 'Move',
    duplicate: 'Duplicate',
    share: 'Share',
    createSlaveSurvey: 'Create Slave Survey',
    review: 'Review',
    chart: 'Chart'
  },
  orderFilter: {
    createtime: 'Create Time',
    updatetime: 'Update Time',
    reply_time_latest: 'Reply Time Latest',
    reply_count: 'Reply Count'
  },
  from: 'From',
  to: 'To',
  startDate: 'Start Date',
  endDate: 'End Date',
  chips: {
    slave: 'Slave',
    master: 'Master',
    pro: 'PRO'
  }
};
